// 세금계산서 발급 완료 헤더 컴포넌트

import { CheckCircle } from 'lucide-react';
import type { InvoiceTranslations } from './types';

interface InvoiceSuccessHeaderProps {
  translations: InvoiceTranslations;
}

export function InvoiceSuccessHeader({ translations }: InvoiceSuccessHeaderProps) {
  return (
    <div className="p-6 text-center border-b border-border">
      <div className="w-16 h-16 bg-green-50 dark:bg-green-900/20 rounded-full flex items-center justify-center mx-auto mb-4">
        <CheckCircle className="w-8 h-8 text-green-500 dark:text-green-400" />
      </div>
      <h2 className="text-xl font-bold text-foreground mb-2 uppercase">
        {translations.invoiceGenerated}
      </h2>
      <p className="text-muted-foreground">{translations.success}</p>
    </div>
  );
}
